var map = {
	"./Coming Together to Represent.jpg": 6961,
	"./Focussed Workshops.jpeg": 7688,
	"./Learning with Fun Activities.jpeg": 6554,
	"./Networking with Peers.jpg": 8228,
	"./Proud Participants.jpeg": 6286,
	"./Rewards & Recognition.jpg": 1534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4090;